import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, change, untouch } from "redux-form";
import { toastr } from "react-redux-toastr";

import TextField from "../../components/Fields/TextField";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import FieldValidation from "../../components/Validation/FieldValidation";
import logo from "../../img/e-registro-logo.png";
import MaskDate from "../../components/Util/MaskDate";

import api from "../../api/apiUtil";

import Title from "../../components/Layout/Title";

class FinancialUserPreRegistration extends React.Component {
  constructor() {
    super();
    this.state = {
      success: false,
    };
  }

  formSubmit(values) {
    const userData = {
      cpf: values.cpf.replace(/[^\d]/g, ""),
      nome: values.nome,
      email: values.email,
      telefone: values.telefone,
    };

    Promise.resolve(api.Financial.createUserPreRegistration(userData))
      .then((ret) => {
        this.setState({ success: true });
        toastr.success("Sucesso", "Pré-cadastro de usuário realizado com sucesso!");
      })
      .catch((error) => {
        if (error && error.response && error.response.body && error.response.body.message) {
          toastr.error("Erro", error.response.body.message);
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar o pré-cadastro de usuário.");
        }
      });
  }

  render() {
    if (this.state.success) {
      return (
        <div>
          <div className="color-line-ereg"></div>
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                <div className="hpanel">
                  <div className="panel-heading">
                    <h5>Pré-cadastro de Usuário</h5>
                  </div>
                  <div className="panel-body">
                    <div className="text-center">
                      <h4>Pré-cadastro realizado com sucesso!</h4>
                      <p>Obrigado pelo seu cadastro. Em breve entraremos em contato.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    const { handleSubmit } = this.props;
    return (
      <div>
        <div className="color-line-ereg"></div>
        <div className="login-img-container">
          <img src={logo} />
        </div>
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <h5>Pré-cadastro de Usuário</h5>
                </div>
                <div className="panel-body">
                  <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmit.bind(this))}>
                    <div className="row">
                      <div className="col-md-4">
                        <Field name="nome" label="Nome" required component={TextField} type="text" validate={[FieldValidation.required]} />
                      </div>
                      <div className="col-md-2">
                        <Field name="cpf" label="CPF" required component={TextField} type="text" validate={[FieldValidation.required, FieldValidation.cpf]} normalize={FieldNormalize.CPF} />
                      </div>
                      <div className="col-md-3">
                        <Field name="email" label="Email" required component={TextField} type="text" validate={[FieldValidation.required, FieldValidation.email]} />
                      </div>
                      <div className="col-md-3">
                        <Field name="telefone" label="Telefone" normalize={FieldNormalize.PHONE} component={TextField} type="text" />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-center" style={{ marginTop: "20px" }}>
                          <button type="submit" className="btn btn-success">
                            Realizar Pré-cadastro
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

// Validation function for the form
const validate = (values) => {
  const errors = {};

  if (!values.nome || values.nome.trim() === "") {
    errors.nome = "Campo obrigatório";
  } else if (values.nome.length > 100) {
    errors.nome = "Máximo de 100 caracteres";
  }

  if (!values.cpf || values.cpf.replace(/[^\d]/g, "").length !== 11) {
    errors.cpf = "CPF inválido";
  }

  if (!values.email || values.email.trim() === "") {
    errors.email = "Campo obrigatório";
  } else if (values.email.length > 100) {
    errors.email = "Máximo de 100 caracteres";
  }

  if (values.telefone && values.telefone.replace(/\D/g, "").length > 0 && (values.telefone.replace(/\D/g, "").length < 10 || values.telefone.replace(/\D/g, "").length > 11)) {
    errors.telefone = "Telefone inválido";
  }

  return errors;
};

const form = reduxForm({
  form: "FinancialUserPreRegistrationForm",
  validate,
});

export default connect(mapStateToProps, mapDispatchToProps)(form(FinancialUserPreRegistration));
